export default {
  palette: {
    // default: {
    //   main: '#ECEFF1'
    // },
    primary: {
      main: '#4F5B62',
    },
    secondary: {
      main: '#D8D8D8',
    },
  },
  typography: {
    fontFamily: [
      'helvetica',
      'aria',
      'Hiragino Kaku Gothic Pro',
      'ヒラギノ角ゴ Pro W3',
      'メイリオ',
      'Meiryo',
      'ＭＳ Ｐゴシック',
      'MS PGothic',
      'sans-serif',
    ].join(','),
  },
  shadows: [
    'none',
    '0px 0px 4px rgba(0,0,0,0.1)',
    '0px 0px 8px rgba(0,0,0,0.1)',
    '0px 0px 10px rgba(0,0,0,0.1)',
    '0px 0px 12px rgba(0,0,0,0.1)',
    '0px 0px 14px rgba(0,0,0,0.1)',
    '0px 0px 16px rgba(0,0,0,0.1)',
    '0px 0px 18px rgba(0,0,0,0.1)',
    '0px 0px 20px rgba(0,0,0,0.1)',
    '0px 0px 22px rgba(0,0,0,0.1)',
    '0px 0px 24px rgba(0,0,0,0.1)',
    '0px 0px 26px rgba(0,0,0,0.1)',
    '0px 0px 28px rgba(0,0,0,0.1)',
    '0px 0px 30px rgba(0,0,0,0.1)',
    '0px 0px 32px rgba(0,0,0,0.1)',
    '0px 0px 34px rgba(0,0,0,0.1)',
    '0px 0px 36px rgba(0,0,0,0.1)',
    '0px 0px 38px rgba(0,0,0,0.1)',
    '0px 0px 40px rgba(0,0,0,0.1)',
    '0px 0px 42px rgba(0,0,0,0.1)',
    '0px 0px 44px rgba(0,0,0,0.1)',
    '0px 0px 46px rgba(0,0,0,0.1)',
    '0px 0px 48px rgba(0,0,0,0.1)',
    '0px 0px 50px rgba(0,0,0,0.1)',
    '0px 0px 52px rgba(0,0,0,0.1)',
  ] as any,
  overrides: {},
}
